import Constants from '@Apis/constants';
import Helpers from '@Apis/helpers';
/**
 * TenantServices class
 *
 * @param tenantId
 * @param userId
 * @param startDate
 * @param endDate
 * @param page
 * @param keyword
 * @param isVerified
 * @param orgId
 * @param limit
 * @param payload
 */
class TenantServices {
    /**
     * @param page
     * @param keyword
     * @param isVerifed
     * @param orgId
     * @param limit
     * @param tenantId
     * @param isVerified
     * @return {Promise<*>}
     */
    getTenants = async (page, keyword, isVerified, orgId, limit, tenantId) => {
      const tenants = Helpers.get({
        url: `${Constants.GET_TENANTS}?page=${page}&tenant_name=${keyword}&map_users=true&org_id=${orgId}&limit=${limit || '100'}${tenantId ? `&tenant_id=${tenantId}` : ''}`,
      });
      return tenants;
    }

    /**
     *
     * @param tenantId
     * @returns {Promise}
     */
    getTenantById = async (tenantId) => {
      const tenant = Helpers.get({
        url: `${Constants.GET_TENANTS}?&tenant_id=${tenantId}`,
      });
      return tenant;
    }

    /**
     * @param payload
     * @param userId
     * @return {Promise<*>}
     */
    createTenant = async (payload, userId) => {
      const createdTenant = Helpers.post({
        url: Constants.CREATE_TENANT,
        data: payload,
      });
      return createdTenant;
    }

    /**
     *
     * @param payload
     * @return {Promise<*>}
     */
    updateTenant = async (payload) => {
      const updatedTenant = Helpers.put({
        url: Constants.UPDATE_TENANT,
        data: payload,
      });
      return updatedTenant;
    }

    /**
     *
     * @param tenantId
     * @param roleId
     * @param userId
     * @return {Promise<*>}
     */
    getUsers = async (tenantId, roleId, permissionType) => {
      let params = '';
      if (roleId) params += `tenant_role_id=${roleId}&`;
      if (tenantId) params += `tenant_id=${tenantId}&`;
      if (permissionType) params += `permission_type=${permissionType}&`;
      const users = Helpers.get({
        url: `${Constants.TENANT_USERS}?${params.substring(0, params.length - 1)}`,
      });
      return users;
    }

    getTenantsAnalytics = async (startDate, endDate, tenantId) => {
      let params = '';
      if (startDate) params += `start_date=${startDate}&`;
      if (endDate) params += `end_date=${endDate}&`;
      if (tenantId) params += `tenant_id=${tenantId}&`;
      const analytics = Helpers.get({
        url: `${Constants.GET_TENANT_ANALYTICS}?${params.substring(0, params.length - 1)}`,
      });
      return analytics;
    }

    /**
     *
     * @param payload
     * @param userId
     * @return {Promise<*>}
     */
    createUser = async (payload) => {
      const createdUser = Helpers.post({
        url: Constants.TENANT_USERS,
        data: payload,
      });
      return createdUser;
    }

    /**
     *
     * @param deleteUserId
     * @return {Promise<void>}
     */
    deleteUser = async (deleteUserId) => {
      const deletedUser = Helpers.delete({
        url: `${Constants.DELETE_USER}?user_id=${deleteUserId}`,
      });
      return deletedUser;
    }

    /**
     *
     * @param payload
     * @return {Promise<unknown>}
     */
    sendWelcomeMail = async (payload) => {
      const mailResponse = Helpers.post({
        url: 'https://h3-helper-servicces.herokuapp.com/api/v1/mail/send/welcome',
        data: payload,
      });
      return mailResponse;
    }

    /**
     *
     * @param {*} tenantId
     * @return
     */
    getTenantsConfiguration = async (tenantId) => {
      const tenants = Helpers.get({
        url: `${Constants.TENANT_CONFIGURATION}${tenantId ? `?tenant_id=${tenantId}` : ''}`,
      });
      return tenants;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
    updateTenantConfiguration = async (payload) => {
      const updatedTenant = Helpers.put({
        url: Constants.TENANT_CONFIGURATION,
        data: payload,
      });
      return updatedTenant;
    }

    /**
     *
     * @param tenantIds
     * @returns {Promise}
     */
    getOrgUsers = async (tenantIds) => {
      const orgUsers = Helpers.get({
        url: `${Constants.ORG_USERS}?tenant_ids=${tenantIds}`,
      });
      return orgUsers;
    }
}

export default new TenantServices();
